/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { NavLink, useLocation, matchPath } from 'react-router-dom';
import Icon from '@icon-park/react/es/all';
import Menu from '../menu/Menu';
import './Breadcrumbs.scss';
function pathNameToRoute(pathname, routes) {
    let route = routes
        .map((path) => matchPath(pathname, { path, exact: true, strict: true }))
        .reduce((prev, curr) => {
        if (!curr)
            return prev;
        if (!!prev.params && Object.keys(prev.params).length <= Object.keys(curr.params).length) {
            return prev;
        }
        return curr;
    }, {}).path;
    if (!route) {
        route = routes
            .map((path) => matchPath(pathname, { path, exact: false, strict: false }))
            .reduce((prev, curr) => {
            if (!curr)
                return prev;
            if (!!prev.params && Object.keys(prev.params).length >= Object.keys(curr.params).length) {
                return prev;
            }
            return curr;
        }, {}).path;
    }
    return route;
}
const Breadcrumb = ({ context, breadcrumbs, isNewBreadcrumb = false }) => {
    const location = useLocation();
    const route = pathNameToRoute(location.pathname, Object.keys(breadcrumbs));
    const breadcrumbDefinition = breadcrumbs[route];
    const { breadcrumbObject } = useContext(context);
    if (breadcrumbDefinition) {
        const items = breadcrumbDefinition(breadcrumbObject);
        const menuItems = items.length > 3 ? items.slice(0, items.length - 3) : [];
        const shownItems = items.length > 3 ? items.slice(items.length - 3) : items;
        // console.log('Breadcrumb ---- - --- - -- ----- ');
        // console.log('items = ', items);
        // console.log('menuItems = ', menuItems);
        // console.log('shownItems = ', shownItems);
        let pageTitle = 'TruRisk';
        shownItems.map((item) => {
            pageTitle += ` - ${item === null || item === void 0 ? void 0 : item.description}` || '';
            return item;
        });
        return (React.createElement("div", { className: `breadcrumbs-container${isNewBreadcrumb ? '-2' : ''}` },
            React.createElement(Helmet, null,
                React.createElement("title", null, pageTitle)),
            !!menuItems.length && (React.createElement(Menu, { buttonProps: { variant: 'text', size: 'small' } }, menuItems.map((item, i) => {
                if (!item.description)
                    return null;
                return (React.createElement("div", { key: i }, item.url ? (React.createElement(React.Fragment, null, item.icon ? (React.createElement(NavLink, { to: item.url, className: "breadcrumbs-button" },
                    React.createElement(Icon, { type: item.icon, theme: "outline", size: 14, strokeWidth: 3 }),
                    React.createElement("span", null, item.description))) : (React.createElement(NavLink, { to: item.url },
                    React.createElement("span", null, item.description))))) : (React.createElement("p", { className: "not-link" },
                    React.createElement("span", null, item.description)))));
            }))),
            shownItems.map((item, i) => {
                if (!item.description)
                    return null;
                return (React.createElement("div", { key: i }, item.url ? (React.createElement(React.Fragment, null, item.icon ? (React.createElement(NavLink, { to: item.url, className: "breadcrumbs-button" },
                    React.createElement(Icon, { type: item.icon, theme: "outline", size: 14, strokeWidth: 3 }),
                    React.createElement("span", null, item.description))) : (React.createElement(NavLink, { to: item.url },
                    React.createElement("span", null, item.description))))) : (React.createElement("p", { className: "not-link" },
                    React.createElement("span", null, item.description)))));
            })));
    }
    return (React.createElement("div", { className: "breadcrumbs-container" },
        React.createElement(Helmet, null,
            React.createElement("title", null, "TruRisk"))));
};
export default Breadcrumb;
